module.exports = __webpack_public_path__ + "static/media/logo-life-seguros-2.e727047b.svg";